import store from '@/store'

export const isAuthenticatedGuard = (to, from, next) => {
  const success = store.getters['auth/isSignedIn']
  if (success) next()
  else next({ name: 'auth-login' })
}

export const isNotAuthenticatedGuard = (to, from, next) => {
  const success = store.getters['auth/isSignedIn']
  if (success) next({ name: 'dashboard-courses' })
  else next()
}
